module.exports = __webpack_public_path__ + "img/adalogo.8b1d2860.png";